module.exports = __webpack_public_path__ + "static/media/add-file.5149ff66.svg";